import React from 'react';

class Distance extends React.Component {
    componentDidMount() {
        this.props.getDistance(this.state.distance);
    }
    state = {
        distance: ''
    }

    onDistanceChange = (e) => {
        const distance = e.target.value;
        this.setState({distance});
        
        this.props.getDistance(distance);
    }

    render() {
        return (
                <input 
                    type="number" 
                    className="inputDistance" 
                    placeholder="Distance"
                    value={this.state.distance} 
                    onChange={this.onDistanceChange} 
                    autoFocus  
                />
        );
    }
}

export default Distance;